import "./youtubePlaylist.css";
import reactJsCrashCourse from "../../assets/images/react-js-crash-course.jpg";
import javaScriptMastery from "../../assets/images/Mastering-Javascript.png";
import nodeJsForBeginners from "../../assets/images/node-js-for-beginners.jpg";
import typeScriptInDepth from "../../assets/images/type-script-in-depth.png";
import fullStackMern from "../../assets/images/full-stack-mern.webp";
import uiUxForDevelopers from "../../assets/images/ui-ux-for-developers.png";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function YoutubePlaylist() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | YouTube List - Watch & Learn</title>
        <meta
          name="description"
          content="Browse SHOP.CO’s curated YouTube list with product showcases, tutorials, and reviews to help you shop smarter."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/resources/youtube-play-list/"
        />
      </Helmet>
      <div className="youtube-playlist-container">
        <h1 className="playlist-title">🎥 Developer YouTube Playlists</h1>
        <p className="playlist-subtitle">A curated list of YouTube playlists to boost your coding journey.</p>

        <div className="playlist-grid">
          <div className="playlist-card">
            <img src={reactJsCrashCourse} alt="React Playlist" />
            <h3>React JS Crash Course</h3>
            <p>Modern React development from the ground up. Learn hooks, components, and state management.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

          <div className="playlist-card">
            <img src={javaScriptMastery} alt="JavaScript Playlist" />
            <h3>JavaScript Mastery</h3>
            <p>Everything from variables to async/await explained clearly for real-world use.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

          <div className="playlist-card">
            <img src={nodeJsForBeginners} alt="Node.js Playlist" />
            <h3>Node.js for Beginners</h3>
            <p>Start backend development with Express, REST APIs, MongoDB and more.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

          <div className="playlist-card">
            <img src={typeScriptInDepth} alt="TypeScript Playlist" />
            <h3>TypeScript in Depth</h3>
            <p>Get started with strong typing in JavaScript and build robust applications with TS.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

          <div className="playlist-card">
            <img src={fullStackMern} alt="Full Stack Playlist" />
            <h3>Full Stack MERN</h3>
            <p>Build full stack apps using MongoDB, Express, React, and Node.js — from start to finish.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

          <div className="playlist-card">
            <img src={uiUxForDevelopers} alt="UI/UX Playlist" />
            <h3>UI/UX for Developers</h3>
            <p>Design beautiful and functional user interfaces with real examples and Figma practice.</p>
            <a href="https://www.youtube.com/channel/UCu_S20xTdjirfws3hJYpCuA" target="_blank" rel="noopener noreferrer" className="playlist-btn">Watch Playlist</a>
          </div>

        </div>
      </div>
    </>
  );
}
